import {P} from 'components/atoms/Text/P';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';
import * as React from 'react';

import './style.scss';
import {Headline} from 'components/atoms/Text/Headline';
import { HeadlineLevel, HeadlineFont } from 'features/ui/enums';

interface Props {
    headline: string;
    text: string;
    link?: string;
}

export const ConceptUsp: React.FunctionComponent<Props> = ({headline, text, link}) => {
    return (
        <div className="usp__block">
            <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF}>{headline}</Headline>
            <P>{text}</P>
            {link && link.length > 0 &&
                <ReadMore
                    block
                    bold
                    link={link}
                />
            }
        </div>
    );
};
